import type { JSX } from "preact";
import { Button } from "@gss/components/Button";
import { Remove } from "@gss/components/icons";
import { useTranslation } from "../util/Translation";

interface Props {
    onClick: () => void;
    buttonText?: boolean;
    className?: string;
    disabled?: boolean;
}

export function ButtonClear({
    onClick,
    buttonText,
    disabled,
    className,
}: Props): JSX.Element {
    const t = useTranslation().translation.filters;
    const text = t.resetSelected;
    return (
        <Button
            variant="default"
            small
            className={className}
            disabled={disabled}
            title={!buttonText ? text : undefined}
            aria-label={!buttonText ? text : undefined}
            onClick={onClick}
        >
            <Remove className="icon-clear" aria-hidden /> {buttonText && text}
        </Button>
    );
}
